import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { EICFConsentsApi } from '../../../apis/EICFApi/EICFConsentsApi.ts';
import { IEICFConsent, ISubmitEICFSignatureRequest } from '../EICFConsent.ts';

export function useSubmitEICFPatientSignature() {
    const queryClient = useQueryClient();
    return useMutation<IEICFConsent, AppMedError, ISubmitEICFSignatureRequest>({
        mutationKey: [QueryKeys.eicfActiveConsent, 'patientSign'],
        mutationFn: (req) => EICFConsentsApi.submitPatientSignature(req),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.eicfActiveConsent] });
        },
    });
}
